import React from 'react';
import { IconProps } from '.';

const SvgPlayFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M19 12 6 20V4l13 8Z' />
    </svg>
  );
};

export default SvgPlayFill;
